import React from "react";
import styles from "@/app/Style/ElementStyle/breadcrumb.module.css"
import Link from "next/link";
// import styles from "@/../../Style/ElementStyle/breadcrumb.module.css";

interface BreadcrumbProps {
  links: { label: string; href: string }[]; // Array of breadcrumb links
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ links }) => {
  return (
    <div className="">
      <h2 className="text-1xl text-gray-800 max-w-[71rem] mb-2 pt-3 mx-auto">
        {
          links.map((link)=>{
            return(
              <Link key={link.href} className="hover:text-[#989fa5]" href={link.href}>
                {` ${link.label}`} / 
              </Link>
            )
          })
        }
      </h2>
    </div>
  );
};

export default Breadcrumb;
